import React from 'react';
import axios from 'axios';
import moment from 'moment';
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../security/securityContext';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';

const INTERVALO_CONSULTA_PADRAO_SEGUNDOS = 120;

export default class PainelMonitorSefaz extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            statusServicos: [],
            carregando: true,
            erro: '',
            ultimaAtualizacao: null,
            proximaAtualizacaoEmSegundos: 0
        };
        this.refreshTimeout = null;
        this.countdownInterval = null;
    }

    componentDidMount() {
        this.buscarStatus();
    }

    componentWillUnmount() {
        this.limparTimers();
    }

    async buscarStatus() {
        try {
            this.setState({ carregando: true, erro: '' });
            const response = await axios.get(`${URL}/monitor-sefaz/status`, SLOW_REQUEST_CONFIG);
            const statusServicos = response.data || [];
            const menorIntervalo = this.recuperarMenorIntervalo(statusServicos);

            this.setState({
                statusServicos,
                carregando: false,
                ultimaAtualizacao: new Date(),
                proximaAtualizacaoEmSegundos: menorIntervalo
            });

            this.agendarProximaConsulta(menorIntervalo);
        } catch (error) {
            this.setState({
                carregando: false,
                erro: 'Nao foi possivel consultar o status da SEFAZ. Tente novamente em instantes.'
            });
            this.agendarProximaConsulta(INTERVALO_CONSULTA_PADRAO_SEGUNDOS);
        }
    }

    recuperarMenorIntervalo(statusServicos) {
        if (!statusServicos.length) {
            return INTERVALO_CONSULTA_PADRAO_SEGUNDOS;
        }

        const intervalosValidos = statusServicos
            .map(item => item.intervaloSegundos)
            .filter(intervalo => Number.isFinite(intervalo) && intervalo > 0);

        if (!intervalosValidos.length) {
            return INTERVALO_CONSULTA_PADRAO_SEGUNDOS;
        }

        return Math.min(...intervalosValidos);
    }

    limparTimers() {
        if (this.refreshTimeout) {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }

        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }
    }

    agendarProximaConsulta(intervaloSegundos) {
        this.limparTimers();

        this.setState({
            proximaAtualizacaoEmSegundos: intervaloSegundos
        });

        this.countdownInterval = setInterval(() => {
            this.setState(prevState => ({
                proximaAtualizacaoEmSegundos: Math.max(prevState.proximaAtualizacaoEmSegundos - 1, 0)
            }));
        }, 1000);

        this.refreshTimeout = setTimeout(() => {
            this.buscarStatus();
        }, intervaloSegundos * 1000);
    }

    renderBadgeStatus(status) {
        const statusNormalizado = (status || '').toUpperCase();
        const online = statusNormalizado === 'ONLINE';
        const estilo = {
            backgroundColor: online ? '#2eb85c' : '#e55353',
            color: '#fff',
            borderRadius: '12px',
            fontSize: '12px',
            padding: '4px 10px',
            fontWeight: 600,
            display: 'inline-block',
            minWidth: '76px',
            textAlign: 'center'
        };

        return <span style={estilo}>{statusNormalizado || 'DESCONHECIDO'}</span>;
    }

    renderCardsResumo() {
        const { statusServicos } = this.state;
        const total = statusServicos.length;
        const online = statusServicos.filter(item => item.ultimoStatus === 'ONLINE').length;
        const offline = statusServicos.filter(item => item.ultimoStatus === 'OFFLINE').length;

        return (
            <div className="row mb-4">
                <div className="col-md-4 col-12 mb-3">
                    <div className="card text-white bg-info">
                        <div className="card-body">
                            <h5 className="card-title mb-1">Total de servicos</h5>
                            <h3 className="mb-0">{total}</h3>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-12 mb-3">
                    <div className="card text-white" style={{ backgroundColor: '#2eb85c' }}>
                        <div className="card-body">
                            <h5 className="card-title mb-1">Servicos online</h5>
                            <h3 className="mb-0">{online}</h3>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-12 mb-3">
                    <div className="card text-white" style={{ backgroundColor: '#e55353' }}>
                        <div className="card-body">
                            <h5 className="card-title mb-1">Servicos offline</h5>
                            <h3 className="mb-0">{offline}</h3>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderTabela() {
        const { statusServicos } = this.state;

        if (!statusServicos.length) {
            return (
                <div className="alert alert-info mt-3" role="alert">
                    Nenhum status de servico encontrado no momento.
                </div>
            );
        }

        return (
            <div className="table-responsive">
                <table className="table table-striped table-hover table-bordered">
                    <thead className="thead-light">
                        <tr>
                            <th>UF</th>
                            <th>Descricao</th>
                            <th>Servico</th>
                            <th>Status</th>
                            <th>Latencia (ms)</th>
                            <th>Ultima verificacao</th>
                            <th>Intervalo (s)</th>
                            <th>Endpoint</th>
                        </tr>
                    </thead>
                    <tbody>
                        {statusServicos.map(item => (
                            <tr key={item.id}>
                                <td>{item.provedor}</td>
                                <td>{item.descricao}</td>
                                <td>{item.nomeServico}</td>
                                <td>{this.renderBadgeStatus(item.ultimoStatus)}</td>
                                <td>{item.latenciaMs || '-'}</td>
                                <td>{item.ultimaVerificacao ? moment(item.ultimaVerificacao).format('DD/MM/YYYY HH:mm:ss') : '-'}</td>
                                <td>{item.intervaloSegundos}</td>
                                <td style={{ maxWidth: '360px', wordBreak: 'break-all' }}>{item.url}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const { carregando, erro, ultimaAtualizacao, proximaAtualizacaoEmSegundos } = this.state;

        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="container-padrao">
                    <Titulo texto="Monitor Sefaz" urlRetorno="/" />

                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                        <div>
                            <strong>Atualizacao automatica:</strong> em {proximaAtualizacaoEmSegundos}s
                        </div>
                        <button type="button" className="btn btn-laranja" onClick={() => this.buscarStatus()}>
                            Atualizar agora
                        </button>
                    </div>

                    {ultimaAtualizacao && (
                        <div className="mb-3">
                            <small className="text-muted">
                                Ultima atualizacao local: {moment(ultimaAtualizacao).format('DD/MM/YYYY HH:mm:ss')}
                            </small>
                        </div>
                    )}

                    {carregando && (
                        <div className="alert alert-secondary" role="alert">
                            Carregando status dos servicos da SEFAZ...
                        </div>
                    )}

                    {erro && (
                        <div className="alert alert-danger" role="alert">
                            {erro}
                        </div>
                    )}

                    {this.renderCardsResumo()}
                    {this.renderTabela()}
                </div>
            </Autorizacao>
        );
    }
}